import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    faqList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
  };

export const faqSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    getFaqList: (state, action) => {
        state.faqList.requesting = true;
        state.faqList.error = null;
        state.faqList.items = [];
        state.faqList.success = false;
        state.faqList.filters = action.payload;
    },
    getFaqListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;
        console.log(action.payload);
        state.faqList.requesting = false;        
        state.faqList.items = data;
        state.faqList.success = true; 
        state.faqList.pagination.current_page = current_page;
        state.faqList.pagination.per_page = per_page;
        state.faqList.pagination.total = total;
    },
    getFaqListFail: (state, action) => {        
        state.faqList.requesting = false;
        state.faqList.error = action.payload;
    },
  },
})

export const { 
    getFaqList, 
    getFaqListSuccess, 
    getFaqListFail,

} = faqSlice.actions;

export default faqSlice.reducer;
